import { VerticalSpacing } from "src/designsystem/VerticalSpacing/VerticalSpacing";
import { FaCheck } from "react-icons/fa";
import { Caption, Heading } from "../FacilityOnboarding.styles";
import { BlockContent, StepCounter, Wrapper } from "./OnboardingStep.styles";

type State =
  | {
      completed: true;
      title: JSX.Element;
      description: JSX.Element;
    }
  | {
      completed: false;
      step: number;
      title: JSX.Element;
      description: JSX.Element;
      children?: JSX.Element;
      footer: JSX.Element;
    };

export function OnboardingStep(state: State) {
  if (state.completed) {
    return (
      <Wrapper>
        <StepCounter completed>
          <FaCheck />
        </StepCounter>
        <BlockContent>
          <div>
            <Heading>{state.title}</Heading>
            <VerticalSpacing size="md" />
            <Caption>{state.description}</Caption>
          </div>
        </BlockContent>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <StepCounter>{state.step}</StepCounter>
      <BlockContent>
        <div>
          <Heading>{state.title}</Heading>
          <VerticalSpacing size="md" />
          <Caption>{state.description}</Caption>
        </div>
        {state.children}
        <div>{state.footer}</div>
      </BlockContent>
    </Wrapper>
  );
}
